import Api from "./Api";
import { createQueryString } from "./ApiHelper";
export default {
  GetGlobalOptions(payload) {
    if (payload) {
      const query = createQueryString(payload);
      return Api().get(
        `/api/v3/external/sales-analytics/global-options${query}`
      );
    } else {
      return Api().get(`/api/v3/external/sales-analytics/global-options`);
    }
  },

  GetCinemas(payload = {}) {
    payload.cine_id =
      payload.cine_id && payload.cine_id.toString().length > 0
        ? payload.cine_id
        : "";
    return Api().post(`/api/v3/external/sales-analytics/getcinemas`, payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/MasterService.js